<div class="public-container">
	<router-outlet></router-outlet>
</div>
